import React from "react";

function MagnetCursor() {
  return (
    <div>
      <div className="magnet">
        <div className="magnet-cursor"></div>
        <div className="magnet-circle"></div>
      </div>
    </div>
  );
}

export default MagnetCursor;
